module.exports = __webpack_public_path__ + "static/media/icon-receive.83db15a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-receive.svg
// module id = 1252
// module chunks = 19